import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import theme from 'theme';
import PolicyParagraph from './PolicyParagraph';
import PolicyBulletList from './PolicyBulletList';

const renderBlock = (block, index) => {
  switch (block.type) {
    case 'paragraph':
      return <PolicyParagraph key={index} runs={block.runs} />;
    case 'bullets':
      return <PolicyBulletList key={index} items={block.items} />;
    default:
      return null;
  }
};

const PolicySection = ({ section }) => (
  <Box sx={{ marginTop: theme.spacing(4) }}>
    <Typography variant="h6" fontWeight={600}>
      {section.title}
    </Typography>
    {section.blocks.map((block, index) => renderBlock(block, index))}
  </Box>
);

PolicySection.propTypes = {
  section: PropTypes.shape({
    title: PropTypes.string.isRequired,
    blocks: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(['paragraph', 'bullets']).isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default PolicySection;
